import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import { ContextGraph } from '@/types/context-graph-types';

export interface CreateContextGraphInput {
  name: string;
  description?: string;
}

export const createContextGraph = async (
  input: CreateContextGraphInput,
): Promise<ContextGraph> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<ContextGraph>({
    url: `/context-graphs/${orgId}`,
    method: 'POST',
    target: 'platform',
    body: {
      orgid: orgId,
      name: input.name,
      description: input.description ?? '',
    },
  });

  if (response.detail) {
    throw new Error(response.detail);
  }
  if (response.data) {
    return response.data;
  }
  throw new Error('Unexpected response format');
};
